import { createSlice } from "@reduxjs/toolkit";
import { fetchCustomers } from "./customersDuck";
import systemReducer, { systemDefaultState } from "../../src/Dashboard/ducks/systemDuck";
import devicesConfigsReducer, { devicesConfigsDefaultState } from "../../src/Dashboard/ducks/devicesConfigsDuck";
import devicesParametersReducer, { devicesParametersDefaultState } from "../../src/Dashboard/ducks/devicesParametersDuck";
import settingsReducer, { settingsDefaultState } from "../../src/Dashboard/ducks/settingsDuck";

const isConfigAction = (action) => {
  const systemId = action.payload?.systemId || action.meta?.arg?.systemId;
  if (!systemId) return false;
  const t = action.type;
  return (
    t.startsWith("system/") ||
    t.startsWith("devicesConfigs/") ||
    t.startsWith("devicesParameters/") ||
    t.startsWith("settings/") ||
    t === "socket/closeSocket"
  );
};

const configTierSlice = createSlice({
  name: "config",
  initialState: {},
  reducers: {
    initializeDeviceConfig(state, action) {
      const { systemId, solutionType } = action.payload;
      if (state[systemId] && !state[systemId]._initialized) {
        state[systemId] = {
          system: systemDefaultState,
          devicesConfigs: devicesConfigsDefaultState,
          devicesParameters: devicesParametersDefaultState,
          settings: settingsDefaultState,
          solutionType: solutionType || state[systemId].solutionType,
          _initialized: true,
        };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        const systems = [];
        action.payload.length > 0 &&
          action.payload.forEach((customer) => systems.push(...customer.devices));
        systems.forEach((sys) => {
          if (!state[sys.deviceId]) {
            state[sys.deviceId] = {
              solutionType: sys.solutionType,
              _initialized: false,
            };
          }
        });
      })
      .addMatcher(isConfigAction, (state, action) => {
        const systemId = action.payload?.systemId || action.meta?.arg?.systemId;
        if (systemId && state[systemId]?._initialized) {
          state[systemId].system = systemReducer(state[systemId].system, action);
          state[systemId].devicesConfigs = devicesConfigsReducer(state[systemId].devicesConfigs, action);
          state[systemId].devicesParameters = devicesParametersReducer(state[systemId].devicesParameters, action);
          state[systemId].settings = settingsReducer(state[systemId].settings, action);
        }
      });
  },
});

export const { initializeDeviceConfig } = configTierSlice.actions;
export default configTierSlice.reducer;
